import React from 'react';
import { Container, Accordion, Row, Col } from 'react-bootstrap';
import { FaExclamationTriangle, FaShieldAlt, FaHourglassHalf, FaBook, FaEnvelope, FaUsers } from 'react-icons/fa';
import {
  PageContainer,
  PageHeader,
  InfoCard,
  AccordionScenario,
  AnimatedSection,
  accordionStyles
} from '../../../components/SharedComponents';

const scenarios = [
  {
    id: 1,
    icon: <FaShieldAlt />,
    title: 'Odwołanie się wprost do przepisu (najbardziej stanowcze)',
    color: '#667eea',
    situation: 'Potrzebuję, żebyś został/a jeszcze dwie godziny, musimy to dokończyć.',
    response: 'Rozumiem, że praca jest ważna, ale niestety nie mogę zostać. Jestem pracownikiem młodocianym i zgodnie z Art. 203 Kodeksu pracy mam bezwzględny zakaz pracy w godzinach nadliczbowych. Muszę przestrzegać tego przepisu, a jutro mam normalnie stawiać się do pracy/szkoły. Chętnie dokończę to jutro rano.'
  },
  {
    id: 2,
    icon: <FaHourglassHalf />,
    title: 'Ustalenie granicy czasowej z powołaniem się na wymóg prawny',
    color: '#f093fb',
    situation: 'Pracodawca chce, abyś pracował/a do późna, wchodząc już w porę nocną (po 22:00, lub po 20:00 w szczególnych przypadkach).',
    response: 'Dziękuję za docenienie mojej pracy, ale niestety zbliżamy się do godziny, po której nie mogę już pracować. Moja zmiana kończy się o [podaj godzinę] i ze względu na mój status młodocianego pracownika prawo zabrania mi pracy w porze nocnej (Art. 203 KP). Muszę opuścić stanowisko o [podaj godzinę]. Jak mogę przygotować zadanie do przejęcia przez inną osobę?'
  },
  {
    id: 3,
    icon: <FaBook />,
    title: 'Odwołanie się do obowiązków (np. szkolnych) i ochrony zdrowia',
    color: '#4facfe',
    situation: 'Daj spokój, to tylko pół godziny. Musisz się nauczyć elastyczności.',
    response: 'Bardzo mi zależy na tej pracy, ale muszę dbać o zdrowie i o to, by wypełniać obowiązek szkolny, zgodnie z prawem dotyczącym młodocianych. Art. 203 Kodeksu pracy ma mnie chronić, dlatego nie mogę ulec tej prośbie. Chciał(a)bym uniknąć naruszenia przepisów, które mogłoby mieć konsekwencje dla obydwu stron. Mogę przygotować szczegółową notatkę, żeby rano można było łatwo przejąć zadanie.'
  },
  {
    id: 4,
    icon: <FaEnvelope />,
    title: 'Odpowiedź pisemna lub w wiadomości (przy formalnym poleceniu)',
    color: '#43e97b',
    situation: 'Pracodawca wysyła służbową wiadomość e-mail lub SMS z poleceniem pracy po godzinach.',
    response: 'Dziękuję za informacje, ale uprzejmie informuję, że jako pracownik młodociany, zgodnie z Art. 203 Kodeksu pracy, mam całkowity zakaz wykonywania pracy w godzinach nadliczbowych i w porze nocnej. W związku z tym, nie jestem w stanie wykonać tego polecenia. Opuściłem/am stanowisko o [godzina końca zmiany]. Chętnie podejmę to zadanie zaraz po rozpoczęciu mojej zmiany jutro, w godzinach pracy młodocianego.'
  },
  {
    id: 5,
    icon: <FaUsers />,
    title: 'Zastosowanie w obecności innej osoby (jeśli sytuacja jest napięta)',
    color: '#f5576c',
    situation: 'Pracodawca próbuje Cię zawstydzić lub zmanipulować, abyś został/a, np. w obecności starszego kolegi.',
    response: 'Przepraszam, ale nie. Moje zatrudnienie jest regulowane przez specjalne przepisy, a Art. 203 Kodeksu pracy jasno określa, że nie wolno mi pracować dłużej niż mój dzienny wymiar czasu pracy i poza wyznaczonymi godzinami. Jest to obowiązujący przepis, który chroni młodocianych i nie mogę go naruszyć. Do zobaczenia jutro.'
  }
];

const Overtime = () => {
  return (
    <PageContainer>
      <Container>
        <style>{accordionStyles}</style>
        
        <PageHeader 
          title="Praca w nadgodzinach"
          subtitle="Gotowe wzory rozmów o nadgodzinach i ich rozliczeniu"
        />

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <AnimatedSection>
              <InfoCard>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                  Jako pracownik młodociany masz bezwzględny zakaz pracy w godzinach nadliczbowych i w porze nocnej 
                  (Art. 203 Kodeksu pracy). Poniżej znajdziesz gotowe szablony odpowiedzi na różne sytuacje.
                </p>
              </InfoCard>
            </AnimatedSection>

            <Accordion alwaysOpen>
              {scenarios.map((scenario, index) => (
                <AccordionScenario
                  key={scenario.id}
                  scenario={scenario}
                  index={index}
                  eventKey={String(index)}
                  argumentLabel="Sytuacja"
                  responseLabel="Asertywna odpowiedź"
                  argumentField="situation"
                />
              ))}
            </Accordion>

            <AnimatedSection delay={0.6} className="mt-4">
              <InfoCard
                gradient="rgba(255, 0, 0, 0.1)"
                borderColor="rgba(255, 0, 0, 0.3)"
                icon={<FaExclamationTriangle style={{ color: '#ff0000' }} />}
                title="Pamiętaj"
              >
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                  W przypadku pracownika młodocianego zakaz pracy w nadgodzinach i w porze nocnej 
                  jest bezwzględny, co oznacza, że nawet zgoda pracownika nie uchyla tego zakazu. 
                  Odmowa wykonania polecenia w tej sytuacji nie może skutkować konsekwencjami dyscyplinarnymi.
                </p>
              </InfoCard>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
};

export default Overtime;